/* eslint-disable max-len */
import React, { useRef, useState } from "react";
import { useOnClickOutside } from "../../CommonMethods/OutsideClick";

function getInitials(firstName, lastName) {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
}

export default function DropdownWithSearchSingleSelect({
    label,
    placeholder,
    searchPlaceholder,
    options,
    selectedOption,
    onSelect,
    onClear,
}) {
    const ref = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useOnClickOutside(ref, () => setIsOpen(false));

    const filteredOptions = options?.filter((option) => option.user_name?.toLowerCase().includes(searchTerm.trim().toLowerCase())) || [];

    return (
        <div className='relative' ref={ref}>
            <p className='text-xs font-semibold text-[#000] pb-1.5'>{label}</p>
            {selectedOption ? (
                <div className='flex items-center justify-between border border-[#C5C9DA] rounded-lg pl-1.5 pr-3.5 py-1.5 bg-[#CCE7E7]'>
                    <div className='flex items-center'>
                        <span className='w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold text-[#972E4C] bg-[#E7CBD2] shrink-0'>
                            {getInitials(selectedOption.first_name, selectedOption.last_name)}
                        </span>
                        <span className='text-sm font-normal text-[#000000] ml-2.5 more-lines'>{selectedOption.user_name}</span>
                    </div>
                    <button type='button' data-testid='clear-association-filter' onClick={onClear}>
                        <img src="/images/cross_mark_gray.svg" alt="clear" />
                    </button>
                </div>
            ) : (
                <button type='button' onClick={() => setIsOpen(!isOpen)} className='border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full outline-none bg-white flex justify-between items-center'>
                    <p className='text-[#52555D] text-start text-sm'>{placeholder}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={isOpen ? 'transform rotate-180' : ''} />
                </button>
            )}
            {isOpen && (
                <ul className='py-2 pr-1 pl-3 rounded-lg bg-white z-[9] absolute top-[68px] w-full left-0 border border-[#C5C9DA]'>
                    <li className='pr-2 mb-2'>
                        <div className='relative'>
                            <input
                                type='text'
                                autoComplete='off'
                                placeholder={searchPlaceholder}
                                className='border border-[#972E4C] rounded-lg pl-9 px-3 py-1.5 w-full outline-none text-sm'
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm}
                            />
                            <img src="/images/search_gray.svg" alt="icon" className='absolute top-[50%] -translate-y-[50%] left-3' />
                        </div>
                    </li>
                    <ul className='max-h-[300px] overflow-auto scrollbar_gray pr-1'>
                        {filteredOptions.length === 0 && <li className='text-center text-sm text-[#52555D] py-2'>No results found.</li>}
                        {filteredOptions.map((option) => (
                            <li
                                key={option.user_id}
                                data-testid={`association-filter-option-${option.user_id}`}
                                className='flex items-center py-2 pr-2 cursor-pointer hover:bg-[#F8EEF1] rounded'
                                onClick={() => { onSelect(option); setIsOpen(false); setSearchTerm(''); }}
                            >
                                <span className='w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold text-[#972E4C] bg-[#E7CBD2] shrink-0'>
                                    {getInitials(option.first_name, option.last_name)}
                                </span>
                                <span className='text-sm font-normal text-[#031624] ml-2.5 more-lines'>{option.user_name}</span>
                            </li>
                        ))}
                    </ul>
                </ul>
            )}
        </div>
    );
}
